// extracted by mini-css-extract-plugin
export default {"badge":"NotificationCount_badge__c6QkE"};